export default "__VITE_ASSET__CJu3_ecz__"